import { createContext, useState } from 'react';

const INITIAL_STATE = {
  title: '',
  onTitleChange: () => undefined,
};

const headerContext = createContext(INITIAL_STATE);

function HeaderProvider({ children }) {
  const [title, setTitle] = useState('');

  const onTitleChange = (t) => {
    setTitle(t);
  };

  return (
    <headerContext.Provider
      value={{
        onTitleChange,
        title,
      }}
    >
      {children}
    </headerContext.Provider>
  );
}

export { headerContext, HeaderProvider };
